import { getCloudPaymentsErrorMessage } from './cloudPaymentsErrorMessages.utils';

const DEFAULT_PAYMENT_FAIL_MESSAGE = 'Оплата не удалась';

/** Extract ReasonCode from CloudPayments widget / API fail payloads */
export const extractCloudPaymentsReasonCode = (
  paymentResult: unknown,
): string | number | undefined => {
  if (!paymentResult || typeof paymentResult !== 'object') {
    return undefined;
  }

  const result = paymentResult as Record<string, any>;

  return (
    result.data?.ReasonCode ??
    result.ReasonCode ??
    result.reasonCode ??
    result.Model?.ReasonCode ??
    result.model?.ReasonCode ??
    result.data?.reasonCode
  );
};

const extractCloudPaymentsResultMessage = (paymentResult: unknown): string | undefined => {
  if (!paymentResult || typeof paymentResult !== 'object') {
    return undefined;
  }

  const result = paymentResult as Record<string, any>;
  const candidateMessages = [
    result.message,
    result.Message,
    result.CardHolderMessage,
    result.cardHolderMessage,
    result.Model?.CardHolderMessage,
    result.model?.CardHolderMessage,
    result.data?.message,
    result.data?.CardHolderMessage,
  ];

  for (const candidateMessage of candidateMessages) {
    if (typeof candidateMessage === 'string' && candidateMessage.trim()) {
      return candidateMessage.trim();
    }
  }

  return undefined;
};

export const resolveCloudPaymentsFailMessage = (
  reason?: string | number | null,
  paymentResult?: unknown,
): string => {
  const reasonCode = extractCloudPaymentsReasonCode(paymentResult) ?? reason;
  const mappedMessage = getCloudPaymentsErrorMessage(reasonCode);

  if (mappedMessage) {
    return mappedMessage;
  }

  const resultMessage = extractCloudPaymentsResultMessage(paymentResult);
  if (resultMessage) {
    return resultMessage;
  }

  if (typeof reason === 'string' && reason.trim()) {
    return reason.trim();
  }

  return DEFAULT_PAYMENT_FAIL_MESSAGE;
};
